import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Collapsible from '../Common/Collapsible/Collapsible';
import Help from '../Common/Help/Help';
import './FAQ.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class FAQ extends Component {
  	render() {
		return (
			<div className="showtix-section container">
				<div className="row">
					<div className="col-12">
						<h1 id="sr-title">{strings.title}</h1>
					</div>
				</div>

				<div className="row">
					<div className="col-12 col-lg-8">
						{strings.categories.map((category, i) =>  
							<div key={i}>
								<h2>{category.title}</h2>
								{category.faqs.map((faq, j) =>  
									<Collapsible key={j} faq={faq} />
								)}
							</div>
						)}
					</div>	
					{ strings.helps &&
						<div className="col-12 col-lg-4">
							{strings.helps.map((help, i) =>
								<Help help={help} key={i} /> 
							)}
						</div>	
					}
				</div>
			</div>
		);
  	}
}

export default FAQ;



// WEBPACK FOOTER //
// ./src/components/FAQ/FAQ.js